import api from "../../utils/Api";
import {
  SUBMIT_CLAIM_REQUEST,
  SUBMIT_CLAIM_SUCCESS,
  SUBMIT_CLAIM_ERROR,
} from "./SubmitClaimTypes";

export const submitClaimRequest = () => {
  return {
    type: SUBMIT_CLAIM_REQUEST,
  };
};

export const submitClaimSuccess = (submitClaimData) => {
  return {
    type: SUBMIT_CLAIM_SUCCESS,
    payload: submitClaimData,
  };
};

export const submitClaimFailure = (error) => {
  return {
    type: SUBMIT_CLAIM_ERROR,
    payload: error,
  };
};

export const submitClaim = (payload) => {

    const headers = {
        'Content-Type': 'application/json',
        Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        };
  return async (dispatch) => {
    dispatch(submitClaimRequest());
    try {
        const response = await api.post("mediswitch/claimsubmit", payload, {
            headers: headers,
          });
      const submitClaimData = response.data.data;
     // console.log("submitClaimData", submitClaimData)
      dispatch(submitClaimSuccess(submitClaimData));
    } catch (error) {
      console.log("Redux error - ", error.response.data.message);
      const errorMsg = error.response.data.message;
      dispatch(submitClaimFailure(errorMsg));
    }
  };
};
